import { cva } from "class-variance-authority";
import { colors } from "./colors.js";

export { default as Indicator } from "./Indicator";

export const sizes = [
    "3xs",
    "2xs",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl",
    "3xl",
    "4xl",
];

export const variants = cva(
    ["flex", "items-center", "justify-center", "overflow-hidden", "shrink-0"],
    {
        variants: {
            size: {
                "3xs": ["h-4.5", "w-4.5", "rounded-xs", "p-1"],
                "2xs": ["h-5.5", "w-5.5", "rounded-sm", "p-[5px]"],
                xs: ["h-6", "w-6", "rounded-sm", "p-[5px]"],
                sm: ["h-8", "w-8", "rounded-md", "p-2"],
                md: ["h-10", "w-10", "rounded-lg", "p-2.5"],
                lg: ["h-11", "w-11", "rounded-lg", "p-3"],
                xl: ["h-14", "w-14", "rounded-2xl", "p-3.5"],
                "2xl": ["h-18", "w-18", "rounded-4xl", "p-5"],
                "3xl": ["h-20", "w-20", "rounded-4xl", "p-5"],
                "4xl": ["h-24", "w-24", "rounded-5xl", "p-6"],
            },
            placeholder: {
                false: ["p-0", "!bg-utility-gray-200"],
            },
        },
        compoundVariants: [...colors],
    }
);
